import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

const Awards = props => {
  const { height, isMobile } = useViewport();
  const {
    data,
    match: { params },
    sectionHeading,
  } = props;
  const isParams = params ? Object.keys(params)[0] : '';
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  if (!props.data) {
    return null;
  }

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };
  const lengthOfSliders = data.length < 5 ? 1 : data.length - 3;
  let className = 'awards-section-container section-container';
  if (isMobile) {
    className = 'awards-section-container';
  }

  return (
    <div className={className} style={{ height }} id={'awards'}>
      <div className="awards-inner-section">
        {!isMobile ? (
          <div className="title">
            <h1>Awards</h1>
            {isParams !== undefined ? (
              <h4>This Project have won {data.length} awards</h4>
            ) : (
              <h4>Our Homes have won {data.length} awards</h4>
            )}
          </div>
        ) : (
          <div className="title">
            {isParams !== undefined ? (
              <h2>This Project have won {data.length} awards</h2>
            ) : sectionHeading ? (
              <h3>{sectionHeading}</h3>
            ) : (
              <h2>Our Homes have won {data.length} awards</h2>
            )}
          </div>
        )}
        {data ? (
          <HorizontalCarousel
            data={data}
            type={!isMobile ? 'awardCard' : 'awardCardMobile'}
            cssFor={'awardCard'}
            getActiveSlide={e => {
              setActiveSlide(e);
            }}
            handleSliderRef={handleSliderRef}
          />
        ) : null}
        {!isMobile ? (
          <div className="section-footer">
            <PaginationControl
              className={'section-footer-item'}
              theme={'dark-theme'}
              mode={'slider'}
              currentIndex={activeSlide + 1}
              total={lengthOfSliders}
              onNextClick={next}
              onPreviousClick={previous}
              key={'17'}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default withRouter(Awards);
